import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglecastComponent } from './simple-icons-googlecast.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglecastComponent ],
    exports:      [ SimpleIconsGooglecastComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglecastModule {}
